import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";

import { BaseContractController } from "../_baseDealController";
import { ContractService } from "../../services/contract-service";
import { EntityService } from "../../services/entity-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AdminService } from "../../services/admin-service";
import { AclService } from "../../services/acl-service";


export class ContractDetailsController extends BaseContractController {
    static $inject = ["$scope", "$window", "$q", "contractService", "entityService",
        "contractSharedDataService", "localCacheService", "notifyService", "eventService", "adminService", "$interval", "aclService",
        "$location", "$anchorScroll"];

    contractID: string;
    initialized: boolean;
    editMode: boolean;
    locked: boolean;

    charTypeName: string;
    listUrl: string;
    canEdit: boolean;

    canCreate: boolean = true;
    showAdvance: boolean = true;
    allowMultiple: boolean = true;
    canCopy: boolean;

    constructor($scope: ng.IScope,
        private $window: ng.IWindowService,
        $q: ng.IQService,
        private contractService: ContractService,
        entityService: EntityService,
        sharedData: ContractSharedDataService,
        localStorage: LocalCacheService,
        notifyService: NotifyService,
        private eventService: EventService,
        adminService: AdminService,
        $interval: ng.IIntervalService,
        private aclService: AclService,
        public $location: ng.ILocationService,
        public $anchorScroll: ng.IAnchorScrollService
    ) {

        super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

        this.contractID = "";
        this.initialized = false;
        this.editMode = false;
        this.locked = false;
        this.charTypeName = "";
        this.listUrl = "~/";
        this.canEdit = false;
        this.canCopy = false;

        $scope.$watch(
            () => this.sharedData.contract != null ? this.sharedData.contract.charDataCollection.status.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });

        this.$scope.$on(Consts.Events.RefreshDealDetails, (e, data) => {
            if (!_.isEmpty(data)) {
                this.sharedData.RefreshContract(data);
            }
        });

        this.$scope.$on(Consts.Events.ViewEntity, (e, data) => {
            if (!_.isEmpty(data)) {
                this.ViewEntity(data);
            }
        });

        this.$scope.$watch(() => {
            if (this.contractID == null) {
                return null;
            } else {
                return this.contractID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        return this.sharedData.RefreshContract(newValue);
                    });
                }
            });
    }

    Init(contractID: string, charTypeName: string, listUrl: string, isSummaryPage: boolean = false) {
        this.contractID = contractID;

        this.RefreshDetails();
        this.RefreshAssets();

        if (!_.isEmpty(charTypeName)) {
            this.charTypeName = charTypeName;
        }
        if (!_.isEmpty(listUrl)) {
            this.listUrl = listUrl;
        }

        this.aclService.loadActivityAcls()
            .then((acls) => {
                this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
                if (isSummaryPage) {
                    this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod4.Summary);
                }
                else {
                    this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod4.Details);
                }
            });
    }

    RefreshAll(): ng.IPromise<any> {
        var promises = [];
        promises.push(this.RefreshValidation());
        return this.$q.all(promises);
    }

    RefreshDetails() {
        return this.sharedData.RefreshContract(this.contractID)
            .then((result) => {
                this.initialized = true;
            }, () => {
                this.notifyService.notifyError("Contract Not Found");
            });
    }

    RefreshAssets() {
        this.notifyService.startProgress();
        this.sharedData.RefreshAssets(this.contractID)
            .then(() => {
                this.initialized = true;
            }, () => {
                this.notifyService.notifyError("Contract Not Found");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    Edit() {
        this.editMode = true;
    }

    Cancel() {
        this.notifyService.startProgress();
        this.entityService.getEntityCharData(this.sharedData.contract.record.id)
            .then((result) => {
                this.sharedData.contract.charDataCollection = result;
                this.editMode = false;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Save(isValid: boolean) {

        if (isValid) {
            this.notifyService.startProgress();
            this.entityService.saveCharData(this.sharedData.contract.record.id, this.sharedData.contract.charDataCollection.charDatas)
                .then(() => {
                    this.notifyService.notifySuccess("Save Successful");
                    return this.RefreshDetails();
                }, this.notifyService.errorResponseHandler)
                .then(() => {
                    this.editMode = false;
                    this.RefreshValidation();
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });

        }
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this " + this.charTypeName + "?") && this.$window.confirm("Are you REALLY SURE you want to delete this " + this.charTypeName + "?")) {
            this.notifyService.startProgress();
            this.contractService.deleteContract(this.contractID)
                .then(() => {
                    this.$window.location.assign(this.listUrl);
                },
                    () => {
                        this.notifyService.notifyError("Error Deleting " + this.charTypeName);
                    })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.notifyService.broadcastDone();
        }
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }
}
